import React, { useState } from 'react';
import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import Button from '@material-ui/core/Button';
import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import Avatar from '@material-ui/core/Avatar';
import ListItemText from '@material-ui/core/ListItemText';
import Divider from '@material-ui/core/Divider';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';
import ToggleButton from '@material-ui/lab/ToggleButton';
import AdsClickIcon from '@mui/icons-material/AdsClick';
import HubIcon from '@mui/icons-material/Hub';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import handleOpenWhatsApp from 'services/whatsappService';

const Option = ({
  title,
  annualPrice,
  monthlyPrice,
  features,
  idealFor,
  duration,
  buttonText,
  highlightedTitle,
  highlightedContent,
  highlightedButtonText,
  icon,
}) => {
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  const [pricingOption, setPricingOption] = useState('monthly');

  const handleClick = (event, newPricingOption) => {
    if (newPricingOption !== null) {
      setPricingOption(newPricingOption);
    }
  };

  // Función para obtener el icono basado en el nombre
  const getIcon = (iconName) => {
    const iconProps = { style: { fontSize: '4rem' } };
    
    switch (iconName) {
      case 'HubIcon':
        return <HubIcon {...iconProps} />;
      default:
        return <AdsClickIcon {...iconProps} />;
    }
  };

  return (
    <Grid container spacing={isMd ? 0 : 2}>
      <Grid item xs={12} md={6}>
        <Card data-aos={isMd ? 'fade-right' : 'fade-up'}>
          <Box component={CardContent} padding={{ sm: 2 }}>
            <Box display={'flex'} justifyContent={'center'} marginBottom={2}>
              <ToggleButtonGroup
                value={pricingOption}
                exclusive
                onChange={handleClick}
              >
                <ToggleButton
                  value="annual"
                  size={'small'}
                  sx={{
                    backgroundColor:
                      pricingOption === 'annual'
                        ? `${theme.palette.primary.light} !important`
                        : 'transparent',
                    border: `1px solid ${theme.palette.primary.main}`,
                  }}
                >
                  <Typography
                    variant="subtitle2"
                    sx={{
                      fontWeight: 'medium',
                      color:
                        pricingOption === 'annual'
                          ? theme.palette.common.white
                          : 'primary',
                    }}
                  >
                    Trimestral
                  </Typography>
                </ToggleButton>
                <ToggleButton
                  value="monthly"
                  size={'small'}
                  sx={{
                    backgroundColor:
                      pricingOption === 'monthly'
                        ? `${theme.palette.primary.light} !important`
                        : 'transparent',
                    border: `1px solid ${theme.palette.primary.main}`,
                  }}
                >
                  <Typography
                    variant="subtitle2"
                    sx={{
                      fontWeight: 'medium',
                      color:
                        pricingOption !== 'annual'
                          ? theme.palette.common.white
                          : 'primary',
                    }}
                  >
                    Mensual
                  </Typography>
                </ToggleButton>
              </ToggleButtonGroup>
            </Box>
            <Box marginBottom={2}>
              <Typography
                fontWeight={600}
                variant={'h2'}
                align={'center'}
                gutterBottom
              >
                {(() => {
                  const price = pricingOption === 'annual' ? annualPrice : monthlyPrice;
                  // Si el precio es un string (como "Trimestral: 800"), mostrarlo tal cual
                  // Si es un número, agregar el símbolo $
                  return typeof price === 'string' ? price : `$${price}`;
                })()}
              </Typography>
              <Typography
                variant={'h4'}
                color={theme.palette.primary.main}
                fontWeight={600}
                align={'center'}
                gutterBottom
              >
                {title}
              </Typography>
              <Typography
                color="text.secondary"
                align={'left'}
                marginLeft={2}
                marginTop={'2rem'}
              >
                EN QUÉ CONSISTE
              </Typography>
            </Box>
            <Grid container spacing={1}>
              {features.map((item, i) => (
                <Grid item xs={12} sm={6} key={i}>
                  <Box
                    component={ListItem}
                    disableGutters
                    width={'auto'}
                    padding={0}
                  >
                    <Box
                      component={ListItemAvatar}
                      minWidth={'auto !important'}
                      marginRight={2}
                    >
                      <Box
                        component={Avatar}
                        bgcolor={theme.palette.secondary.main}
                        width={20}
                        height={20}
                      >
                        <svg
                          width={12}
                          height={12}
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 20 20"
                          fill="currentColor"
                        >
                          <path
                            fillRule="evenodd"
                            d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                            clipRule="evenodd"
                          />
                        </svg>
                      </Box>
                    </Box>
                    <ListItemText primary={item} />
                  </Box>
                </Grid>
              ))}
            </Grid>
            <Box
              display={'flex'}
              justifyContent={'space-between'}
              marginTop={'1rem'}
              paddingX={2}
              flexDirection={isMd ? 'row' : 'column'}
            >
              <Box flex={'1'}>
                <Typography
                  color="text.secondary"
                  align={'left'}
                  marginTop="2rem"
                >
                  IDEAL PARA
                </Typography>
                <Typography
                  color="text.secondary"
                  align={'left'}
                  marginTop={'1rem'}
                >
                  {idealFor}
                </Typography>
              </Box>
              <Box flex={'1'}>
                <Typography
                  color="text.secondary"
                  align={isMd ? 'right' : 'left'}
                  marginTop="2rem"
                >
                  DURACIÓN MÍNIMA
                </Typography>
                <Typography
                  color="text.secondary"
                  align={isMd ? 'right' : 'left'}
                  marginTop={'1rem'}
                >
                  {duration}
                </Typography>
              </Box>
            </Box>
          </Box>
          <Divider />
          <Box component={CardActions} justifyContent={'center'}>
            <Button size={'large'} onClick={handleOpenWhatsApp}>{buttonText}</Button>
          </Box>
        </Card>
      </Grid>
      <Grid item container xs={12} md={6} alignItems={'center'}>
        <Box
          component={Card}
          bgcolor={theme.palette.primary.main}
          data-aos={isMd ? 'fade-left' : 'fade-up'}
        >
          <Box
            component={CardContent}
            padding={{ sm: 4 }}
            display={'flex'}
            flexDirection={'column'}
            alignItems={'center'}
          >
            <Box color={theme.palette.common.white} marginBottom={4}>
              {getIcon(icon)}
            </Box>
            <Box
              component={Typography}
              variant={'h5'}
              color={theme.palette.common.white}
              fontWeight={600}
              align="center"
            >
              {highlightedTitle}
            </Box>
            {highlightedContent.map((content, index) => (
              <Box
                key={index}
                component={Typography}
                color={theme.palette.common.white}
                align={'center'}
                sx={{ mt: 1 }}
              >
                {content}
              </Box>
            ))}
          </Box>
          <Divider />
          <Box component={CardActions} justifyContent={'center'}>
            <Button sx={{ color: theme.palette.common.white }} size={'large'} onClick={handleOpenWhatsApp}>
              {highlightedButtonText}
            </Button>
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
};

export default Option;
